module.exports = __webpack_public_path__ + "img/btn.65b20c56.svg";